import Axios from "@/global/AxiosCall";
import { url } from '@/configs/apiUrl'

/**
 * default API response structure
 * {
 *     code: <integer>,
 *     message: <string>,
 *     data: <object>
 * }
 */
export default class FileAPI {

    /**
     * api call to upload file/document and get link download
     * @param payload
     * @returns {Promise<unknown>}
     */
    static Upload(payload) {
        return new Promise(((resolve, reject) => {
            let formData = new FormData();
            formData.append('file', payload.file);

            Axios.PostUpload(url.content_delivery.upload, formData).then((result) => {
                if (result.code === 200)
                    resolve(result)
                console.log(result);
            }).catch((error) => {
                reject(error)
            });
        }))
    }

    static UploadConfig(payload) {
        return new Promise(((resolve, reject) => {
            let formData = new FormData();
            formData.append('file', payload.file);
            formData.append('data', JSON.stringify(payload.data));
            Axios.PutUpload(url.svd.device_assignment.update, formData).then((result) => {
                if (result.code === 200) {
                    resolve(result)
                } else {
                    reject(result)
                }
            }).catch((error) => {

                reject(error)
            });
        }))
    }

    static UploadDeviceSetupConfig(payload) {
        return new Promise(((resolve, reject) => {
            let formData = new FormData();
            formData.append('file', payload.file);
            formData.append('data', JSON.stringify(payload.data));
            Axios.PutUpload(url.svd.device_setup.update, formData).then((result) => {
                if (result.code === 200) {
                    resolve(result)
                } else {
                    resolve(result)
                }
            }).catch((error) => {
                reject(error)
            });
        }))
    }

    static UploadLocationMappingConfig(payload) {
        return new Promise(((resolve, reject) => {
            let formData = new FormData();
            formData.append('file', payload.file);
            formData.append('data', JSON.stringify(payload.data));
            Axios.PostUpload(url.svd.location_mapping.storeBulk, formData).then((result) => {
                if (result.code === 200) {
                    resolve(result)
                } else {
                    resolve(result)
                }
            }).catch((error) => {
                reject(error)
            });
        }))
    }

    static UploadDeviceMappingConfig(payload) {
        return new Promise(((resolve, reject) => {
            let formData = new FormData();
            formData.append('file', payload.file);
            formData.append('data', JSON.stringify(payload.data));
            Axios.PostUpload(url.svd.device_mapping.storeBulk, formData).then((result) => {
                if (result.code === 200) {
                    resolve(result)
                } else {
                    resolve(result)
                }
            }).catch((error) => {
                reject(error)
            });
        }))
    }

    static UploadSVDLocationMapping(payload) {
        return new Promise(((resolve, reject) => {
            let formData = new FormData();
            formData.append('file', payload.file);
            formData.append('data', JSON.stringify(payload.data));
            Axios.PostUpload(url.svd.svd_location_mapping.storeBulk, formData).then((result) => {
                if (result.code === 200) {
                    resolve(result)
                } else {
                    resolve(result)
                }
            }).catch((error) => {
                reject(error)
            });
        }))
    }

    static UploadExcelBulkStoreMid(payload) {
        return new Promise(((resolve, reject) => {
            let formData = new FormData();
            formData.append('file', payload.file);
            formData.append('data', JSON.stringify(payload.data));
            Axios.PostUpload(url.svd.mid.bulkStore, formData).then((result) => {
                if (result.code === 200) {
                    resolve(result)
                } else {
                    resolve(result)
                }
            }).catch((error) => {
                reject(error)
            });
        }))
    }

    static UploadExcelBulkStoreTid(payload) {
        return new Promise(((resolve, reject) => {
            let formData = new FormData();
            formData.append('file', payload.file);
            formData.append('data', JSON.stringify(payload.data));
            Axios.PostUpload(url.svd.tid.bulkStore, formData).then((result) => {
                if (result.code === 200) {
                    resolve(result)
                } else {
                    resolve(result)
                }
            }).catch((error) => {
                reject(error)
            });
        }))
    }


}